import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    roleType: {
        dev: "Dev",
        employee: "Employé",
        manager: "Manager",
        profileComplete: "Profil complet",
        hasPaid: "A payé",
        patient: "Patient"
    }
};

export type I18nUserTools = typeof _fr;

const _en: I18nUserTools = {
    roleType: {
        dev: "Dev",
        employee: "Employee",
        manager: "Manager",
        profileComplete: "Complete profile",
        hasPaid: "Has paid",
        patient: "Patient"
    }
};

/** 
 * Return i18n definitions associated to given language.
 * If language is null or not handled by the application, the definition for the application's default language will be given
 */
export function i18nUserTools(lang?: string): I18nUserTools {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}